module.exports = __webpack_public_path__ + "img/smb.a2fbeed4.png";